export enum QuestionScoreMode {
  WithScore = 'withScore',
  WithoutScore = 'withoutScore'
}

export enum RelativeScoreMode {
  RelativeToActivity = 'relativeToActivity',
  RelativeToParent = 'relativeToParent'
}
